import { createContext, useContext, useRef, useState } from 'react';
import _ from 'lodash';
import { Button, FormControlLabel, Switch } from '@material-ui/core';
import { t, Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';

import Actions from '../../page-framework/actions/Actions';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { useDeleteDialog } from '../../form/DeleteDialog';

export const ReportActionsContext = createContext({});

export function useReportActionsContextValue() {
    const [showAll, setShowAll] = useState(false);
    const [actionsDisabled, setActionsDisabled] = useState(true);
    const onEnableRef = useRef();
    const setOnEnable = (onEnable) => (onEnableRef.current = onEnable);
    const onDisableRef = useRef();
    const setOnDisable = (onDisable) => (onDisableRef.current = onDisable);
    const onDeleteRef = useRef();
    const setOnDelete = (onDelete) => (onDeleteRef.current = onDelete);

    return {
        showAll,
        setShowAll,
        onEnable: onEnableRef.current || _.noop,
        setOnEnable,
        onDisable: onDisableRef.current || _.noop,
        setOnDisable,
        onDelete: onDeleteRef.current || _.noop,
        setOnDelete,
        actionsDisabled,
        setActionsDisabled,
    };
}

export function useReportActions() {
    return useContext(ReportActionsContext);
}

export default function ReportActions() {
    const [isAdminUser] = useIsAdminUser();
    const [deleteDialog, showDeleteDialog] = useDeleteDialog(
        i18n._(t`Are you sure you want to delete the selected reports?`)
    );
    const reportActionsContext = useReportActions();

    function handleShowAllChange(event) {
        reportActionsContext.setShowAll(event.target.checked);
    }

    function handleDelete() {
        showDeleteDialog(reportActionsContext.onDelete);
    }

    return (
        <Actions>
            {isAdminUser && (
                <FormControlLabel
                    control={<Switch checked={reportActionsContext.showAll} onChange={handleShowAllChange} />}
                    label={<Trans>View All Reports</Trans>}
                />
            )}
            <Button disabled={reportActionsContext.actionsDisabled} onClick={reportActionsContext.onEnable}>
                <Trans>Enable</Trans>
            </Button>
            <Button disabled={reportActionsContext.actionsDisabled} onClick={reportActionsContext.onDisable}>
                <Trans>Disable</Trans>
            </Button>
            <Button disabled={reportActionsContext.actionsDisabled} onClick={handleDelete}>
                <Trans>Delete</Trans>
            </Button>
            {deleteDialog}
        </Actions>
    );
}
